<template>
  <div class="wt-story-toolbox" ref="toolbox">
    <wt-toolbox-bgmusic class="-right-divider" />
    <wt-transition-button class="-right-divider" />
    <wt-transcript-button class="-right-divider" />
    <wt-dropdown-view
      type="menu-down fixed"
      class="-right-divider -no-right-margin -view-toggles-dropdown"
    >
      <template slot="label">
        <i class="wticon wticon-show" /> View
        <i class="wticon -chevron wticon-chevron-down"></i
      ></template>
      <template slot="view">
        <ul>
          <li>
            <wt-beats-button />
          </li>
          <li
            class="zoom-view-item js-zoom-view-item"
            @mouseenter="onZoomViewMouseEnter"
            @mouseleave="onZoomViewMouseLeave"
          >
            <div class="zoom-view-content">
              <i class="wticon wticon-zoom-in" />
              <span class="wt2-text-n -label">Zoom View</span>
              <i class="wticon wticon-chevron-right -chevron-right"></i>
            </div>

            <!-- Submenu -->
            <transition name="slide-submenu">
              <div
                v-show="showZoomSubmenu"
                class="zoom-submenu js-zoom-submenu"
                @mouseenter="onZoomViewMouseEnter"
                @mouseleave="onZoomViewMouseLeave"
              >
                <wt-toolbox-zoom />
              </div>
            </transition>
          </li>
          <!-- <li>
            <wt-scenes-button />
          </li> -->
        </ul>
      </template>
    </wt-dropdown-view>

    <wt-edit-with-ai-button />
    <div class="-vertical-divider -fix-for-flow" />

    <div class="-box-bellow-rcp" ref="bellowRcp">
      <wt-toolbox-undoredo />

      <div class="-spring" />

      <wt-waveform-toggle />
      <div class="-vertical-divider -fix-for-flow" />
      <wt-story-duration />
    </div>
  </div>
</template>

<script>
import wtToolboxBgmusic from './BGMusic/wtToolboxBgmusic.vue';
import wtTransitionButton from './Transition/wtTransitionButton.vue';
import wtStoryDuration from './wtStoryDuration.vue';
import wtToolboxUndoredo from './wtToolboxUndoredo.vue';
import wtToolboxZoom from './wtToolboxZoom.vue';
import wtTranscriptButton from './wtTranscriptButton.vue';
import wtWaveformToggle from './wtWaveformToggle.vue';
import wtBeatsButton from './wtBeatsButton.vue';
import wtEditWithAiButton from './wtEditWithAiButton.vue';
// import wtScenesButton from './wtScenesButton.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'wt-story-toolbox',
  components: {
    wtWaveformToggle,
    wtToolboxBgmusic,
    wtTransitionButton,
    wtStoryDuration,
    wtToolboxUndoredo,
    wtToolboxZoom,
    wtTranscriptButton,
    wtBeatsButton,
    wtEditWithAiButton,
    // wtScenesButton,
  },

  data() {
    return {
      toolboxSizeOnShiftLeft: null,
      listenOnToolbox: null,
      showZoomSubmenu: false,
    };
  },

  mounted() {
    this.listenOnToolbox = new ResizeObserver(this.shiftSpringRight);
    this.listenOnToolbox.observe(this.$refs.toolbox);
  },

  beforeDestroy() {
    this.listenOnToolbox.unobserve(this.$refs.toolbox);
  },

  computed: {
    ...mapGetters(['isSomeTranscribing']),
    ...mapState({
      enableVOSubtitles: (state) => state.story.enableVOSubtitles,
    }),

    isTranscribing() {
      return this.enableVOSubtitles && this.isSomeTranscribing;
    },
  },

  methods: {
    shiftSpringRight(entries) {
      window.requestAnimationFrame(() => {
        if (!Array.isArray(entries) || !entries.length) {
          return;
        }
        const toolboxWidth = entries[0].contentRect.width;
        const canShiftRight = !(
          this.enableVOSubtitles && this.isSomeTranscribing
        );
        if (
          this.toolboxSizeOnShiftLeft &&
          toolboxWidth > this.toolboxSizeOnShiftLeft &&
          canShiftRight
        ) {
          const defaultRightSideWidth = '540px';
          this.toolboxSizeOnShiftLeft = null;
          this.$refs.bellowRcp.style.maxWidth = defaultRightSideWidth;
        }
      });
    },
    onZoomViewMouseEnter(e) {
      this.showZoomSubmenu = true;
    },
    onZoomViewMouseLeave(e) {
      if (!e.target || !e.target.closest('.js-zoom-submenu')) {
        this.showZoomSubmenu = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wt-story-toolbox {
  $padding-right: 20px;
  $rcp-width: 560px;
  display: flex;
  align-items: center;
  padding: 0 $padding-right 0 $padding-right;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid #e6e6e6;

  .-vertical-divider {
    width: 1px;
    height: 50px;
    background: rgb(217, 217, 217);
    margin: 0 15px 0 15px;
  }

  .-right-divider {
    border-right: 1px solid rgb(217, 217, 217);
    height: 50px;
    margin-right: 15px;
    padding-right: 15px;
    &.-no-right-margin {
      margin-right: 0;
    }
  }

  .-fix-for-flow {
    margin: 0;
  }

  .wt-toolbox-bgmusic {
    flex-shrink: 0;
  }

  .wt-transition-button {
    flex-shrink: 0;
    user-select: none;
  }

  .wt-story-duration-alert {
    flex-shrink: 1;
    margin-left: 30px;
  }

  .-spring {
    flex-grow: 1;
  }

  .-box-bellow-rcp {
    display: flex;
    align-items: center;
    max-width: #{$rcp-width - $padding-right};
    width: 100%;
  }

  .wt-toolbox-undoredo {
    margin-left: 20px;
  }

  .-view-toggles-dropdown {
    .-toggle {
      .wticon {
        font-size: 16px;
        font-weight: 100;
        &.-chevron {
          margin-left: 10px;
          font-size: 14px;
        }
      }
      &.-opened {
        .-chevron {
          transform: rotate(180deg);
        }
      }
    }

    /deep/.-box {
      width: 150px;
      margin-left: -16px;
    }
  }

  .zoom-view-item {
    position: relative;
    cursor: pointer;
    height: 50px;
    user-select: none;
    padding-left: 15px;

    &:hover {
      background: rgba(6, 169, 244, 0.1);
    }
  }

  .zoom-view-content {
    display: flex;
    align-items: center;
    height: 100%;

    .wticon {
      font-size: 16px;
      margin-right: 10px;
    }

    .-chevron-right {
      margin-left: auto;
      font-size: 12px;
      opacity: 0.5;
    }

    .-label {
      min-width: 40px;
    }
  }

  .zoom-submenu {
    position: absolute;
    left: 100%;
    top: 0;
    margin-left: 5px;
    background: white;
    border: 1px solid #d9d9d9;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    padding: 9px;
    z-index: 9999;
    transform-origin: left center;

    // Invisible bridge to prevent hide on gap hover
    &::before {
      content: '';
      position: absolute;
      left: -5px;
      top: 0;
      width: 5px;
      height: 100%;
      background: transparent;
    }
  }

  // Slide-in animation (enter)
  .slide-submenu-enter-active {
    transition: all 0.2s ease-out;
  }

  .slide-submenu-enter {
    opacity: 0;
    transform: translateX(-10px) scale(1);
  }

  .slide-submenu-enter-to {
    opacity: 1;
    transform: translateX(0) scale(1);
  }

  // Slide-out animation (leave)
  .slide-submenu-leave-active {
    transition: all 0.15s ease-in;
  }

  .slide-submenu-leave {
    opacity: 1;
    transform: translateX(0) scale(1);
  }

  .slide-submenu-leave-to {
    opacity: 0;
    transform: translateX(-10px) scale(1);
  }
}
</style>
